import { createVNode as l, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/OpenFilled.js";
import p from "../components/PfIcon.js";
const e = (r, t) => {
  const o = {
    ...r,
    ...t.attrs
  };
  return l(p, i(o, {
    icon: n
  }), null);
};
e.displayName = "OpenFilled";
e.inheritAttrs = !1;
export {
  e as default
};
